/**
 * Ebakasi Enterprise Authentication and Identity Session Storage Manager
 */
export const loginUser = (token, userData) => {
  localStorage.setItem('ebakasiJwtToken', token);
  localStorage.setItem('ebakasiUserData', JSON.stringify(userData));
};

export const getAuthToken = () => {
  return localStorage.getItem('ebakasiJwtToken');
};

export const getUserProfile = () => {
  const data = localStorage.getItem('ebakasiUserData');
  return data ? JSON.parse(data) : null;
};

export const isAuthenticated = () => {
  return localStorage.getItem('ebakasiJwtToken') !== null;
};

export const logoutUser = () => {
  localStorage.removeItem('ebakasiJwtToken');
  localStorage.removeItem('ebakasiUserData');
  window.location.reload();
};
